import { Component, signal } from '@angular/core';
import { TamperEventFormComponent } from "@app/components/forms/tamper-event/form.component";
import { TamperEventHelperService } from '@app/services/helpers/tamper-event-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { TamperEventCreate } from '@app/models/tamper-event.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';

@Component({
    selector: 'app-tamper-event-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        TamperEventFormComponent,
        RouterModule,
        FontAwesomeModule,
    ]
})
export class TamperEventCreatePage {
  public title = 'New Tamper Event';
  formValid = signal(false);
  formValue = signal<TamperEventCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private tamperEventService: TamperEventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.tamperEventService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/tamper-events/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
